var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { MediaReception } from './modules/MediaReception';
import { MediaStarter } from './modules/MediaStarter';
import { MediaAborter } from './modules/MediaAborter';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { MediaPlayer } from './player/MediaPlayer';
export class Media {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get app() {
        return this.parent;
    }
    get mediaPlayer() {
        return new MediaPlayer(this);
    }
    get mediaReception() {
        return new MediaReception(this);
    }
    mediaStarter = new MediaStarter(this); // contains reaction
    mediaAborter = new MediaAborter(this); // contains reaction
}
__decorate([
    memoize
], Media.prototype, "mediaPlayer", null);
__decorate([
    memoize
], Media.prototype, "mediaReception", null);
